/* eslint-disable @next/next/no-img-element */
import { FC } from 'react';

import * as Styles from './styles';

interface IToken {
  image: string;
  name: string;
  symbol: string;
}

export const Token: FC<IToken> = ({ image, name, symbol }) => {
  return (
    <Styles.Container>
      <img src={image} alt={name} width={20} height={20} />
      {name}
      <span>{symbol}</span>
    </Styles.Container>
  );
};
